import type { TaskItemResponse } from '@lmc/ts-common'
import DeleteModal from './modals/DeleteModal'
import SnoozeModal from './modals/SnoozeModal'
import StatusModal from './modals/StatusModal'
import TeamModal from './modals/TeamModal'

type TaskModalPorps = {
  modalType: string
  isModalVisible: boolean
  setIsModalVisible: (show: boolean) => void
  task: TaskItemResponse
  refetchDailyTasks: () => Promise<void>
  refetchTasks: () => Promise<void>
}

export type ActionModalProps = {
  task: TaskItemResponse
  isModalVisible: boolean
  setIsModalVisible: (show: boolean) => void
  onSuccess?: () => void
}

const TaskModal = ({
  modalType,
  isModalVisible,
  setIsModalVisible,
  task,
  refetchDailyTasks,
  refetchTasks
}: TaskModalPorps) => {
  const refetchAll = async () => {
    await refetchDailyTasks()
    await refetchTasks()
  }

  if (modalType === 'status') {
    return (
      <StatusModal
        task={task}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        onSuccess={refetchAll}
      />
    )
  }
  if (modalType === 'team') {
    return (
      <TeamModal
        task={task}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    )
  }
  if (modalType === 'snooze') {
    return (
      <SnoozeModal
        task={task}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        onSuccess={refetchAll}
      />
    )
  }
  return (
    <DeleteModal
      task={task}
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      onSuccess={refetchAll}
    />
  )
}

export default TaskModal
